export enum ReimbursableTypeEnum {
  TimeSettingsCustomTimeRangeCategory = 'TimeSettings::CustomTimeRangeCategory',
  FinanceCustomCategory = 'Finance::CustomCategory',
}

export enum PayrollRunStatusEnum {
  Opened = 'opened',
  InReview = 'in_review',
  Closed = 'closed',
}

export * from './currency'

export const COMPENSATIONS_IMPORT_THRESHOLD_MAPPING = 0.6
